// Compiler result to JSON file
import { createComponent } from 'js/declViewModelService';
import { registerDynImportEntry } from 'js/moduleLoader';
import AwParseService from 'js/awParseService';
import AwFilterService from 'js/awFilterService';
import { getField } from 'js/utils';
import { Fragment } from 'react';
let filterSer = AwFilterService.instance;
import AwPanel from 'viewmodel/AwPanelViewModel';
import AwList from 'viewmodel/AwListViewModel';
import AwDefaultCell from 'viewmodel/AwDefaultCellViewModel';

/*
ctx imports
*/

const ctxImportObj = {};

/*
dynamic import
 */
registerDynImportEntry('js/accHttpService', () => import('js/accHttpService'));
registerDynImportEntry('js/accEventBus', () => import('js/accEventBus'));
;

/*
view model
 */
const declViewModelJson = {
  "schemaVersion": "1.0.0",
  "data": {
    "projectsSkip": 0
  },
  "dataProviders": {
    "listProjectsDataProvider": {
      "action": "getProjects",
      "response": "{{projects}}",
      "totalFound": "{{totalCount}}",
      "contextMenuCommandsAnchor": "des_project_options"
    }
  },
  "actions": {
    "listProjectsdataProviderMethod": {
      "actionType": "dataProvider",
      "method": "listProjectsDataProvider"
    },
    "getProjects": {
      "actionType": "JSFunctionAsync",
      "method": "createHttpRequest",
      "inputData": {
        "request": {
          "method": "POST",
          "url": "/acc/orchestrate",
          "withCredentials": true,
          "data": {
            "appBaseUrl": "assets",
            "additionalProperties": {},
            "query": "query getProjects( $getProjectsInput: GetProjectsInput) { getProjects( getProjectsInput: $getProjectsInput) { items totalCount skip}}",
            "variables": {
              "getProjectsInput": {
                "collaborationspaceId": "{{props.collaborationspaceid}}",
                "skip": "{{data.projectsSkip}}"
              }
            }
          }
        },
        "progressIndicatorPrefix": "collab",
        "accSessionId": "{{props.accsessionid}}"
      },
      "outputData": {
        "projects": "data.data.getProjects.items",
        "projectsSkip": "data.data.getProjects.skip",
        "totalCount": "data.data.getProjects.totalCount"
      },
      "actionMessages": {},
      "deps": "js/accHttpService"
    },
    "publishToACCEventBus": {
      "actionType": "JSFunction",
      "method": "publish",
      "inputData": {
        "eventId": "{{parameters.eventId}}",
        "eventData": "{{parameters.eventData}}"
      },
      "deps": "js/accEventBus"
    }
  },
  "conditions": {
    "validInput": {
      "expression": "props.accsessionid && props.accsessionid.length > 0 && props.collaborationspaceid && props.collaborationspaceid.length > 0"
    }
  },
  "onEvent": [{
    "eventId": "listProjectsDataProvider.selectionChangeEvent",
    "action": "publishToACCEventBus",
    "inputArgs": {
      "eventId": "des-list-projects-as-list.projectSelected",
      "eventData": "{{eventData.selectedObjects}}"
    }
  }],
  "lifecycleHooks": {
    "onMount": "",
    "onUpdate": {
      "action": "listProjectsdataProviderMethod",
      "observers": ["props.accsessionid", "props.collaborationspaceid"]
    }
  },
  "i18n": {},
  "props": {
    "accsessionid": {
      "type": "string"
    },
    "collaborationspaceid": {
      "type": "string"
    }
  },
  "_viewModelId": "ListProjectsAsList",
  "_uniqueViewModelId": "ListProjectsAsList",
  "ctx": {}
};

/*
<aw-panel class="aw-layout-full">
    <aw-list dataprovider="data.dataProviders.listProjectsDataProvider" hasFloatingCellCommands="false">
        <aw-default-cell vmo="item"></aw-default-cell>
    </aw-list>
</aw-panel>

*/
const renderFn = props => {
  let subPanelContext = props.subPanelContext;
  let {
    viewModel: {
      data,
      dataProviders,
      dispatch,
      conditions,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    },
    grids,
    ctx,
    actions,
    fields,
    messages,
    i18n,
    formProp,
    viewPath
  } = props;
  data = {
    ...data,
    dataProviders
  };
  if (subPanelContext && subPanelContext.fields) {
    fields = {
      ...fields,
      ...subPanelContext.fields
    };
  }
  let $index = null;
  return /*#__PURE__*/React.createElement(AwPanel, {
    revealAction: actions.reveal,
    className: "aw-layout-full"
  }, /*#__PURE__*/React.createElement(AwList, {
    dataprovider: dataProviders.listProjectsDataProvider,
    showDropArea: null,
    dndHandler: props.viewModel.dndHandler,
    hasfloatingcellcommands: "false"
  }, ({
    item,
    index
  }) => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, "            ", /*#__PURE__*/React.createElement(AwDefaultCell, {
      vmo: AwParseService.instance("item")({
        props,
        data,
        fields,
        dataProviders,
        ctx,
        i18n,
        actions,
        subPanelContext,
        viewPath,
        conditions,
        formProp,
        dispatch,
        selectionModels,
        editHandlers,
        chartProviders,
        ports,
        item,
        index
      })
    }));
  }));
};

/*
define component
*/
const Component = createComponent(declViewModelJson, renderFn, undefined, ctxImportObj);
export default Component;